// td-safety-stats — animate count-up values when section enters viewport.
(function () {
  function animateCounter(el) {
    if (el.dataset.tdAnimated === '1') return;
    el.dataset.tdAnimated = '1';

    var target = parseFloat(el.dataset.target || '0');
    var decimals = parseInt(el.dataset.decimals || '0', 10);
    var duration = parseInt(el.dataset.duration || '1400', 10);
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReduced || !Number.isFinite(target)) {
      el.textContent = target.toFixed(decimals);
      return;
    }

    var start = performance.now();
    function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }
    function tick(now) {
      var t = Math.min(1, (now - start) / duration);
      var v = target * easeOutCubic(t);
      el.textContent = v.toFixed(decimals);
      if (t < 1) requestAnimationFrame(tick);
      else el.textContent = target.toFixed(decimals);
    }
    requestAnimationFrame(tick);
  }

  function init(root) {
    if (!root || root.dataset.tdInit === '1') return;
    root.dataset.tdInit = '1';

    var counters = root.querySelectorAll('[data-td-counter]');

    if (!('IntersectionObserver' in window)) {
      root.classList.add('is-visible');
      counters.forEach(animateCounter);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          root.classList.add('is-visible');
          counters.forEach(animateCounter);
          io.disconnect();
        }
      });
    }, { threshold: 0.25 });
    io.observe(root);
  }

  function bootAll() {
    document.querySelectorAll('.td-stats').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  // Re-init for Shopify theme editor section reloads.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector) {
      e.target.querySelectorAll('.td-stats').forEach(init);
    }
  });
})();
